/**
 * Autoplays product gallery videos (Shopify-hosted or external) when they
 * scroll into view, and pauses them when they scroll back out.
 * Targets <deferred-media> elements inside video slides of the product
 * media gallery (media-gallery.js / media.js from the theme).
 */
class VideoScrollAutoplay {
  constructor() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });
    this.init();
  }

  init() {
    const targets = document.querySelectorAll(
      '.product-media-container--video deferred-media, .product-media-container--external_video deferred-media'
    );
    targets.forEach((el) => this.observer.observe(el));
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      const el = entry.target;

      if (entry.isIntersecting) {
        if (!el.getAttribute('data-media-loaded') && typeof el.loadContent === 'function') {
          el.loadContent(false);
        }
        if (typeof el.playMedia === 'function') {
          el.playMedia();
        }
      } else if (typeof el.pauseMedia === 'function') {
        el.pauseMedia();
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VideoScrollAutoplay());
} else {
  new VideoScrollAutoplay();
}
